export const CATEGORY_EMOJIS = {
    history: '🕘',
    smileys_emotion: '😀',
    people_body: '👦',
    animals_nature: '🐶',
    food_drink: '🍔',
    travel_places: '🏠',
    activities: '⚽',
    objects: '💡',
    symbols: '🔣',
    flags: '🏴',
};
